import { DocumentNode, gql } from '@apollo/client';

export const GenerateReportPDFRequest: DocumentNode = gql`
    mutation GenerateReportPDFRequest($input: ReportResultPDFInput) {
        generateReportPDFRequest(input: $input) {
            ID
            Status
            __typename
        }
    }
`;
